






































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getCompanies, deleteCompany, getBusinessDevelopers } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import Company from '../models/Company';
import { companyTypes } from '@/data/companyTypes';
import HeaderDatatable from '../models/HeaderDatatable';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import { formatLegalForm } from '@/data/legalForms';
import Datatable from '@/components/Datatable.vue';
import moment from 'moment';
import Boolean from '@/components/Boolean.vue';
import cloneDeep from 'lodash/cloneDeep';
import FilterComponent from '@/components/FilterComponent.vue';
import User from '@/models/User';
import CompanyExportModal from '@/components/CompanyExportModal.vue';

@Component({
    components: {
        Datatable,
        Boolean,
        FilterComponent,
        CompanyExportModal,
    },
    filters: {
        formatLegalForm,
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatType: (value: string) => {
            return get(companyTypes, value, value);
        },
        displayMandat: (value: number, company: Company,) => {
            if (typeof value == 'undefined') {

                if(company.is_multi_mandat === undefined || company.is_multi_mandat === ""){
                    return 'NC';
                }
                return 'MR';
            } else {
                return value;
            }
        },
    },
})
export default class Companies extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Nom Sté',
            dataIndex: 'name',
            sorter: true,
            scopedSlots: {
                customRender: 'name',
            },
        },
        {
            title: "Type d'entreprise",
            dataIndex: 'type',
            sorter: true,
            scopedSlots: {
                customRender: 'type',
            },
        },
        {
            title: 'Note Promoteur',
            dataIndex: 'nb_of_stars',
            sorter: true,
            scopedSlots: {
                customRender: 'nb_of_stars',
            },
        },
        {
            title: "Business Developper",
            dataIndex: 'business_developper.firstname',
            sorter: true,
            scopedSlots: {
                customRender: 'business_developper',
            },
        },
        {
            title: 'Espace partenaire',
            dataIndex: 'api_available',
            sorter: true,
            scopedSlots: {
                customRender: 'boolean',
            },
            align: 'center',
        },
        {
            title: 'Flux connecté',
            dataIndex: 'api_connected',
            sorter: true,
            scopedSlots: {
                customRender: 'boolean',
            },
            align: 'center',
        },
        {
          title: 'Nb Total Progs',
          dataIndex: 'nb_programs',
        },
        {
            title: 'Nb Programmes Diffusés',
            dataIndex: 'nb_total_programs_diffused',
            sorter: true,
            align: 'center',
        },
        {
            title: 'Sauv. Maj',
            dataIndex: 'contacted_at',
            sorter: true,
            scopedSlots: {
                customRender: 'date',
            },
        },
        {
            title: 'Nb prog saisir',
            dataIndex: 'nb_programs_to_enter',
            sorter: true,
        },
        {
            title: 'N° mandat',
            dataIndex: 'mandat.num_mandat',
            scopedSlots: {
                customRender: 'mandat',
            },
            sorter: true,
        },
        {
            title: 'Échéance mandat',
            dataIndex: 'mandat.date_due',
            scopedSlots: {
                customRender: 'date',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    async fetch(meta: MetaDatatable) {
        const { data } = await getCompanies({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }
    deleteText = {
        confirm: {
            title: `Suppression de l'entreprise`,
            content: `Voulez-vous vraiment supprimer l'entreprise ?`,
        },
        notify: {
            title: 'entreprise supprimé',
            content: `L'entreprise a bien été supprimé`,
        },
    };

    get companyTypes() {
        return Object.keys(companyTypes).map(type => ({
            value: `#${type}`, // on ajout un char pour éviter une collision de clé avec le constructor
            text: get(companyTypes, type),
        }));
    }

    onFilterType(value: string | undefined) {
        if (value) {
            this.typeModel = value;
            this.meta.filters = {
                type: value.substr(1), // on enléve ici le #
            };
        } else {
          this.typeModel = undefined;
            this.meta.filters =  {
              type: undefined
            };
        }
    }
  onFilterBusinessDevelopper(value: string | undefined) {
    if (value) {
      this.businessDevelopperModel = value;
      this.meta.filters = {
        bdCompany: value, // on enléve ici le #
      };
    } else {
      this.businessDevelopperModel = undefined;
      this.meta.filters = {
        bdCompany: undefined,
      };
    }
  }

  onFilterPartnerwebsite(value: string | undefined) {
      if (value) {
        this.partnerWebsite = value;
        this.meta.filters = {
          api_available: value, // on enléve ici le #
        };
      } else {
        this.partnerWebsite = undefined;
        this.meta.filters = {
          api_available: undefined,
        };
      }
  }

  onFilterFlux(value: string | undefined){
    if(value){
      this.fluxModel = value;
      this.meta.filters = {
        api_connected: value
      }
    }else {
      this.meta.filters = {
        api_connected: null
      }
      this.fluxModel = undefined;
    }
  }

  onFilterMandate(value: string | undefined){
    if(value){
      this.mandateFilter = value;
      this.meta.filters = {
        mandate: value
      }
    }else{
      this.meta.filters = {
        mandate: null
      }
      this.mandateFilter = undefined;
    }
  }
  async fetchBusinessDevelopper(){
    const dataBusinessDeveloppers = await getBusinessDevelopers();
    return dataBusinessDeveloppers.data.map(
        (item: User) => ({
          text: item.firstname  + " - " + item.email,
          value: item.id || 0,
        })
    );
  }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Company | null;
    }) {
        const action = ev.action;
        const company: Company | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (company !== null) {
                    this.$router.push({
                        name: 'editCompany',
                        params: {
                            id: `${company.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (company && company.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteCompany(company.id);
                }
                break;
        }
    }

    deleteDialog(company: Company) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(company),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(company: Company) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: company });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de l'entreprise`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    filterOption(input: any, option: any) {
        return (
            option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
    }

    excelModalVisible: boolean = false;

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    typeModel: string | undefined | null = null;
    businessDevelopperModel: string | undefined | null = null;
    fluxModel: string | undefined | null = null;
    partnerWebsite: string | undefined | null = null;
    mandateFilter: string | undefined | null = null;
    created() {
        this.typeModel = undefined;
        this.businessDevelopperModel = undefined;
        this.fluxModel = undefined;
        this.partnerWebsite = undefined;
        this.mandateFilter = undefined;
    }

    @Watch('meta', { deep: true })
    onMeta() {
        if (this.meta.filters) {
          if(this.meta.filters.type) {
            this.typeModel = `#${this.meta.filters.type}`;
          }
          if (this.meta.filters.bdCompany){
            this.businessDevelopperModel = this.meta.filters.bdCompany;
          }
          if (this.meta.filters.api_available) {
            this.partnerWebsite = this.meta.filters.api_available;
          }
          if (this.meta.filters.api_connected) {
            this.fluxModel = this.meta.filters.api_connected;
          }
          if(this.meta.filters.mandate) {
            this.mandateFilter = this.meta.filters.mandate;
          }
        } else {
            this.typeModel = undefined;
        }
    }
}
